import './HomeOffersBottom.css'

const HomeOffersBottom = () => {

    return (
        <div className="home-offers-bottom-main-container" >
            <div className='home-offers-bottom-column'>
                <div className='home-offers-bottom-text'>Sei un libero professionista?</div>
                <div className='home-offers-bottom-text'>Cerchi una soluzione per la tua azienda?</div>
                <div className='home-offers-bottom-row'>
                    <a className='home-offers-bottom-link' href='/offerte-per-i-professionisti/'>
                        <button className='home-offers-bottom-purple-button'>Offerte liberi professionisti</button>
                    </a>
                    <a className='home-offers-bottom-link' href='/offerte-per-le-aziende/'>
                        <button className='home-offers-bottom-blue-button'>Offerte aziendali</button>
                    </a>
                </div>
            </div>
            <img className='home-offers-bottom-image' src='https://www.digitalreti.com/wp-content/uploads/2021/05/libero_professionista.png' alt='bottom-image'></img>
        </div>
    )
}

export default HomeOffersBottom
